






















import { Prop, Component, Vue } from "vue-property-decorator";
import EstimatePurchaseItem from "../presenters/estimate-purchase-item";
import EstimatePurchaseRow from "./EstimatePurchaseRow.vue";

@Component({
  components: {
    EstimatePurchaseRow
  }
})
export default class PurchaseOption extends Vue {
  @Prop({ required: true }) option!: EstimatePurchaseItem;

  get status(): string {
    return this.option.isPurchased() ? "発行済" : "未発行";
  }
}
